import styled from '@emotion/styled';
import xw from 'xwind';

export const RoleTag = styled.span<{ main?: boolean; invertColor?: boolean }>`
  ${xw`
      rounded-full text-xs md:text-sm`}
  color: ${({ main }) => (main ? '#5fa3a9' : '#000000')};
  height: min-content;
  padding: 0 13px;
  width: fit-content;
  background-color: ${({ invertColor }) => (invertColor ? '#fff' : '#f3f4f8')};
  @media (min-width: 640px) {
    font-size: 15px;
  }
`;
